module.exports = __webpack_public_path__ + "img/icon-target.070cdfe2.svg";